<script lang="ts">
    import Router, { link } from 'svelte-spa-router'
    import { onMount } from 'svelte'
    import { propsWrapper } from '../../../core/router/helper'
    import type ServiceProvider from '../services/service.provider'
    import type DataProvider from '../services/data.provider'
    import type { ICategory } from '../interfaces/category.interface'
    import { slugify } from '../../../core/helpers/string.helper'
    import AppError from './Error.svelte'

    export let serviceProvider: ServiceProvider
    export let dataProvider: DataProvider

    let processingCategories: boolean = false;
    let errorCategories: boolean = false;
    let categories: ICategory[] = []

    let selectedCategoryId = null
    let selectedSubCategoryId = null

    const props = { serviceProvider, dataProvider }
    const routes = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        '/:categoryId': propsWrapper(() => import('./SubCategory.svelte'), props),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        '/:categoryId/*': propsWrapper(() => import('./SubCategory.svelte'), props),
    }

    window.addEventListener(
        "popstate",
        function (_event: any) {
            var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

            if (isMobile) {
                if (!window.location.hash || window.location.hash == "#/") {
                    selectedCategoryId = null;
                } else if (window.location.hash.length > 0) {
                    let split = window.location.hash.split('/');

                    if (split && split.length >= 2) {
                        let itemParts = split[1].split('-');

                        if (itemParts && itemParts.length > 0) {
                            selectedCategoryId = itemParts[0];
                        } else {
                            window.location.reload();
                        }
                    }
                }
            }
        },
        false
    );

    dataProvider.selectedCategoryIdSubs.subscribe((status) => selectedCategoryId = status)
    dataProvider.selectedSubCategoryIdSubs.subscribe((status) => selectedSubCategoryId = status)

    // CATEGORIES

    serviceProvider.categoryService.processingCategoriesSubs.subscribe((status) => (processingCategories = status))
    serviceProvider.categoryService.errorCategoriesSubs.subscribe((status) => (errorCategories = status))
    serviceProvider.categoryService.categoriesSubs.subscribe((data) => categories = data)

    onMount(() => serviceProvider.categoryService.loadCategories())
</script>

{#if processingCategories}
    <!-- <p>Načítám...</p> -->
{:else if errorCategories}
    <AppError />
{:else}
    <div class="bno-category-list" class:subcategories-visible={selectedCategoryId} class:tasks-visible={selectedSubCategoryId}>
        <div class="bno-category-list__inner">
            <div class="bno-category-list__col bno-category-list__categories">
                <div class="bno-category-list__col-inner is-active">
                    <ul class="bno-category-list__nav">
                        {#each categories as category}
                            <li class="bno-category-list__nav-item">
                                <a
                                    href="/{category.id}-{slugify(category.nazev)}"
                                    title="{category.nazev}"
                                    aria-label="{category.nazev}"
                                    class="bno-category-list__nav-link has-arrow"
                                    class:is-active={selectedCategoryId == category.id}
                                    use:link
                                    on:click|preventDefault={() => {
                                        selectedCategoryId = category.id;
                                    }}
                                >
                                    <h4>
                                        <span class="bno-link">{category.nazev}</span>
                                    </h4>
                                </a>
                            </li>
                        {/each}
                    </ul>
                </div>
            </div>
            {#if categories.length}
                <Router {routes}/>
            {/if}
            {#if !selectedCategoryId}
                <div class="bno-category-list__col bno-category-list__subcategories"/>
            {/if}
            {#if !selectedSubCategoryId}
                <div class="bno-category-list__col bno-category-list__tasks"/>
            {/if}
        </div>
    </div>
{/if}
